import { DIALOG_DATA } from '@angular/cdk/dialog';
import {
  AfterViewInit,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UserSchema } from '../../models';
import { UserService } from '../../services';

@Component({
  selector: 'auth-activation',
  templateUrl: './activation.component.html',
  styleUrls: ['./activation.component.scss'],
})
export class ActivationComponent implements OnInit {
  public userData = this.dialogData.user;

  constructor(
    private snakeBar: MatSnackBar,
    private userService: UserService,
    private dialogRef: MatDialogRef<ActivationComponent>,
    @Inject(DIALOG_DATA) private dialogData: { user: UserSchema }
  ) {
    this.activationState = this.userData?.phone ? 'confirmCode' : 'updatePhone';
  }

  async ngOnInit() {
    this.isActivated = await this.userService.isUserActivated();

    this.userService.status$.subscribe((data) => {
      if (data.status === 'update' && data.payload) {
        this.userData = data.payload;
      }
    });
  }

  public isActivated!: boolean;
  public isGoogleAuthenticated!: boolean;
  public activationState!: 'updatePhone' | 'confirmCode';

  toggle(to: 'confirmCode' | 'updatePhone') {
    this.activationState = to;
  }

  onActivation(event: boolean) {
    this.dialogRef.close(event);
  }

  onPhoneUpdate(event: boolean) {
    if (event) {
      this.snakeBar.open('شماره تلفن تغییر کرد', 'باشه', {
        duration: 1000,
      });
    }
  }
}
